import { PipelineAPI } from '../../pipelines/api/PipelineAPI';
import { NotificationsAPI } from '../NotificationsAPI';
import { RawPreferencesFactory } from '../Preferences/Factory';
import { Preference } from '../Preferences/Interface';
import { getRawDataForSelectedPipelines } from '../Subscriptions/Utils';

export class UserAlertService {
  getSubscriptions() {
    return Promise.all([
      PipelineAPI.getIntegrations(),
      NotificationsAPI.getSubscribedPipelinesList()
    ]);
  }

  unSubscribePipelines(items: Set<string | number>) {
    return NotificationsAPI.unSubscribePipelines(getRawDataForSelectedPipelines(items));
  }

  subscribePipelines(items: Set<string | number>) {
    return NotificationsAPI.subscribePipelines(getRawDataForSelectedPipelines(items));
  }

  getPreferences() {
    return NotificationsAPI.getPreferences();
  }

  getUserPreferencesMetaData() {
    return NotificationsAPI.getUserPreferencesMetaData();
  }

  savePreferences(preferences: Preference[]) {
    return NotificationsAPI.savePreferences(RawPreferencesFactory(preferences));
  }
}
